export default "__VITE_ASSET__BtZtRwWW__"